import React, {useEffect, useRef, useState} from 'react';
import carte from "../../assets/img/carte.jpg"
import hotel from "../../assets/img/hotel.jpg"
import lobby from "../../assets/img/lobby.jpg"
import restaurant from "../../assets/img/restaurant.jpg"
import wellness from "../../assets/img/wellness.jpg"
import six360 from "../../assets/img/6-360.jpg"
import aquaparkImg from "../../assets/img/aquapark.jpg"
import aquapark from "../../assets/video/aquapark-opti.mp4"
import naturaparkImg from "../../assets/img/naturapark.jpg"
import naturapark from "../../assets/video/naturapark-opti.mp4"
import tyroImg from "../../assets/img/tyro.jpg"
import tyro from "../../assets/video/tyro-lac-opti.mp4"
import funpark from "../../assets/img/funpark.jpg"
import cableImg from "../../assets/img/cable.jpg"
import cable from "../../assets/video/cable-park-opti.mp4"
import vitaImg from "../../assets/img/vita.jpg"
import vita from "../../assets/video/vitapark-opti.mp4"
import salle1 from "../../assets/img/SalleConference4.jpg"
import salle1T from "../../assets/img/SalleConference4Thumb.jpg"
import salle2 from "../../assets/img/SalleConference5.jpg"
import salle2T from "../../assets/img/SalleConference5Thumb.jpg"
import salle3 from "../../assets/img/SalleConference7.jpg"
import salle3T from "../../assets/img/SalleConference7Thumb.jpg"
import salle4 from "../../assets/img/SalleConference8.jpg"
import salle4T from "../../assets/img/SalleConference8Thumb.jpg"
import salle5 from "../../assets/img/SalleConference11.jpg"
import salle5T from "../../assets/img/SalleConference11Thumb.jpg"
import "./plan.css"
import useScrollOnDrag from 'react-scroll-ondrag'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css"

const images = [
    {
        original: salle1,
        thumbnail: salle1T
    },
    {
        original: salle2,
        thumbnail: salle2T
    },
    {
        original: salle3,
        thumbnail: salle3T
    },
    {
        original: salle4,
        thumbnail: salle4T
    },
    {
        original: salle5,
        thumbnail: salle5T
    }
]




function Plan({ runScroll }) {
    const [is360, setIs360] = useState(false)
    const [size, setSize] = useState(1)
    const [isShown, setIsShown] = useState(false);
    let [isPop, setIsPop] = useState(false);
    const [isShown2, setIsShown2] = useState(false);
    let [isPop2, setIsPop2] = useState(false);
    const [isShown3, setIsShown3] = useState(false);
    let [isPop3, setIsPop3] = useState(false);
    const [isShown4, setIsShown4] = useState(false);
    let [isPop4, setIsPop4] = useState(false);
    const [isShown5, setIsShown5] = useState(false);
    let [isPop5, setIsPop5] = useState(false);
    const [isShown6, setIsShown6] = useState(false);
    let [isPop6, setIsPop6] = useState(false);
    const [isShown7, setIsShown7] = useState(false);
    let [isPop7, setIsPop7] = useState(false);
    const [isShown8, setIsShown8] = useState(false);
    let [isPop8, setIsPop8] = useState(false);
    const [isShown9, setIsShown9] = useState(false);
    let [isPop9, setIsPop9] = useState(false);
    const [isShown10, setIsShown10] = useState(false);
    let [isPop10, setIsPop10] = useState(false);
    const [isShown11, setIsShown11] = useState(false);
    let [isPop11, setIsPop11] = useState(false);
    const [isShown12, setIsShown12] = useState(false);
    let [isPop12, setIsPop12] = useState(false);
    const ref = useRef(null);
    const { events } = useScrollOnDrag(ref);

    function close() {
        setIsPop(false)
        setIsShown(false)
        setIsPop2(false)
        setIsShown2(false)
        setIsPop3(false)
        setIsShown3(false)
        setIsPop4(false)
        setIsShown4(false)
        setIsPop5(false)
        setIsShown5(false)
        setIsShown6(false)
        setIsPop6(false)
        setIsShown7(false)
        setIsPop7(false)
        setIsShown8(false)
        setIsPop8(false)
        setIsShown9(false)
        setIsPop9(false)
        setIsShown10(false)
        setIsPop10(false)
        setIsShown11(false)
        setIsPop11(false)
        setIsShown12(false)
        setIsPop12(false)
        /*setIsPop2(false)
        setIsShown2(false)
        setIsPop3(false)
        setIsShown3(false)
        setIsPop4(false)
        setIsShown4(false)*/
    }


    function toggleLeave() {
        setTimeout(function () {
            setIsShown(false)
            setIsShown2(false)
            setIsShown3(false)
            setIsShown4(false)
            setIsShown5(false)
            setIsShown6(false)
            setIsShown7(false)
            setIsShown8(false)
            setIsShown9(false)
            setIsShown10(false)
            setIsShown11(false)
            setIsShown12(false)
        }, 1200)
    }

    /*function showImg1(src) {
        return (
            <div className="tools" data-toggle="tooltip"
                 style={{position: "absolute", top: "57%", left: "45%", maxWidth: "100%", height: "auto", zIndex: "2"}}>
                <img className="thumb" style={{width: "150px"}} onMouseLeave={() => setIsShown(false)}
                     onClick={() => setIsPop(true)} src={src} alt={src}/>
                <span>Hotel</span>
            </div>
        )
    }*/

    function popUp1(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Hotel</h3>
                </span>
                <img className="thumb" style={{width: "100%"}} src={src} alt={src}/>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    function popUp2(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Lobby</h3>
                </span>
                <img className="thumb" style={{width: "100%"}} src={src} alt={src}/>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    function popUp3(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Restaurant bistronomique</h3>
                </span>
                <img className="thumb" style={{width: "100%"}} src={src} alt={src}/>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    function popUp4(src) {
        return (
            <div className="popup" style={{width: "40vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Centre Séminaire</h3>
                </span>
                {/*<img className="thumb" style={{width: "100%"}} src={src} alt={src}/>*/}
                <ImageGallery items={images} showPlayButton={false} showFullscreenButton={false}/>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    function popUp5(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Espace Wellness</h3>
                </span>
                <img className="thumb" style={{width: "100%"}} src={src} alt={src}/>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    //6
   /* function showImg6(src) {
        return (
            <div className="tools" data-toggle="tooltip"
                 style={{position: "absolute", top: "57%", left: "45%", maxWidth: "100%", height: "auto", zIndex: "2"}}>
                <img className="thumb" style={{width: "150px"}} onMouseLeave={() => setIsShown6(false)}
                     onClick={() => setIsPop6(true)} src={src} alt={src}/>
                <span>Vue lac inférieur</span>
            </div>
        )
    }*/

    function popUp6() {
        return (
            <div className=" popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <iframe id="inlineFrameExample"
                        title="Inline Frame Example"
                        width="100%"
                        height="700px"
                        src="https://apps.go-moon.com/miysis/r&d/plan-interactif-lamy/six360/">
                </iframe>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    //7
    /*function showImg7(src) {
        return (
            <div className="tools" data-toggle="tooltip"
                 style={{position: "absolute", top: "55%", left: "58%", maxWidth: "100%", height: "auto", zIndex: "2"}}>
                <img className="thumb" style={{width: "150px"}} onMouseLeave={() => setIsShown6(false)}
                     onClick={() => setIsPop7(true)} src={src} alt={src}/>
                <span>Aquapark</span>
            </div>
        )
    }*/

    function popUp7(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Aqua park</h3>
                </span>
                <video controls width={"100%"}>
                    <source src={aquapark} type={"video/mp4"}/>
                </video>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    function popUp8(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Natura park</h3>
                </span>
                <video controls width={"100%"}>
                    <source src={naturapark} type={"video/mp4"}/>
                </video>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }
    function popUp9(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Tyrolienne sur lac</h3>
                </span>
                <video controls width={"100%"}>
                    <source src={tyro} type={"video/mp4"}/>
                </video>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }
    function popUp10() {
        return (
            <div className=" popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <iframe id="inlineFrameExample"
                        title="Inline Frame Example"
                        width="100%"
                        height="700px"
                        src="https://apps.go-moon.com/miysis/r&d/plan-interactif-lamy/360ten/">
                </iframe>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    function popUp11(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Cable Park</h3>
                </span>
                <video controls width={"100%"}>
                    <source src={cable} type={"video/mp4"}/>
                </video>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }
    function popUp12(src) {
        return (
            <div className="popup" style={{width: "60vw", height: "auto", zIndex: "20"}}>
                <span className={"titleName"}>
                <h3>Vita Park</h3>
                </span>
                <video controls width={"100%"}>
                    <source src={vita} type={"video/mp4"}/>
                </video>
                <button className="closePopUp" onClick={() => close()}><i className="fas fa-times"/></button>
            </div>
        )
    }

    //10
    /*function showImg10(src) {
        return (
            <div className="tools" data-toggle="tooltip"
                 style={{position: "absolute", top: "75%", left: "75%", maxWidth: "100%", height: "auto", zIndex: "2"}}>
                <img className="thumb" style={{width: "150px"}} onMouseLeave={() => setIsShown10(false)}
                     onClick={() => setIsPop10(true)} src={src} alt={src}/>
                <span>Funpark</span>
            </div>
        )
    }*/

    return (
        <div {...events} ref={ref} id="container">
            {/*<MapInteractionCSS minScale={1} showControls={true} >*/}
            <TransformWrapper options={{maxScale: 1.4}} pan={{padding: true, paddingSize: 0}} wheel={{wheelEnabled: true, step: 100}}>
                <TransformComponent>
            <div id="image" style={{transform: `scale(${size})`}}>


                        <img id="mapImg" src={carte} alt="Carte Lamy"/>


                <div className="circleBase type3" onClick={() => setIsPop(true)} /*onMouseLeave={() => toggleLeave()}*/
                     /*onMouseEnter={() => setIsShown(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">1</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span className="namedTooltip">1. Hotel</span><img className={"thumb"} style={{width: '150px'}} src={hotel}/></span></span></span>
                </div>
                <div className="circleBase2 type3" onClick={() => setIsPop2(true)} /*onMouseLeave={() => toggleLeave()}*/
                    /*onMouseEnter={() => setIsShown(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">2</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span className="namedTooltip">2. Lobby</span><img className={"thumb"} style={{width: '150px'}} src={lobby}/></span></span></span>
                </div>
                <div className="circleBase3 type3" onClick={() => setIsPop3(true)} /*onMouseLeave={() => toggleLeave()}*/
                    /*onMouseEnter={() => setIsShown(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">3</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{fontSize: '14px', width: '100%', left: '0%'}} className="namedTooltip">3. Restaurant bistronomique</span><img className={"thumb"} style={{width: '150px'}} src={lobby}/></span></span></span>
                </div>
                <div className="circleBase4 type3" onClick={() => setIsPop4(true)} /*onMouseLeave={() => toggleLeave()}*/
                    /*onMouseEnter={() => setIsShown(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">4</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{ width: '100%', left: '0%', bottom: '-25%'}} className="namedTooltip">4. Centre Séminaire</span><img className={"thumb"} style={{width: '150px'}} src={salle1}/></span></span></span>
                </div>
                <div className="circleBase5 type3" onClick={() => setIsPop5(true)} /*onMouseLeave={() => toggleLeave()}*/
                    /*onMouseEnter={() => setIsShown(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span  className="tooltip-item">5</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%'}} className="namedTooltip">5. Espace Wellness</span><img className={"thumb"} style={{width: '150px'}} src={lobby}/></span></span></span>
                </div>
               {/* {isShown && (
                    showImg1(hotel)
                )}*/}
                <div className="circleBase6 type3" onClick={() => setIsPop6(true)} /*onMouseLeave={() => toggleLeave()}*/
                     /*onMouseEnter={() => setIsShown6(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">6</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%', bottom: '-29%'}} className="namedTooltip">6. Vue lac inférieure</span><img className={"thumb"} style={{width: '150px'}} src={six360}/></span></span></span>
                </div>
                {/*{isShown6 && (
                    showImg6(six360)
                )}*/}
                <div className="circleBase7 type3" onClick={() => setIsPop7(true)} /*onMouseLeave={() => toggleLeave()}
                     onMouseEnter={() => setIsShown7(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">7</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%'}} className="namedTooltip">7. Aqua Park</span><img className={"thumb"} style={{width: '150px'}} src={aquaparkImg}/></span></span></span>
                </div>
                <div className="circleBase8 type3" onClick={() => setIsPop8(true)} /*onMouseLeave={() => toggleLeave()}
                     onMouseEnter={() => setIsShown7(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">8</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%'}} className="namedTooltip">8. Natura Park</span><img className={"thumb"} style={{width: '150px'}} src={naturaparkImg}/></span></span></span>
                </div>
                <div className="circleBase9 type3" onClick={() => setIsPop9(true)} /*onMouseLeave={() => toggleLeave()}
                     onMouseEnter={() => setIsShown7(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">9</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%'}} className="namedTooltip">9. Tyrolienne sur lac</span><img className={"thumb"} style={{width: '150px'}} src={tyroImg}/></span></span></span>
                </div>
                {/*{isShown7 && (
                    showImg7(aquaparkImg)
                )}*/}
                <div className="circleBase10 type3" onClick={() => setIsPop10(true)} /*onMouseLeave={() => toggleLeave()}
                     onMouseEnter={() => setIsShown10(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">10</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%'}} className="namedTooltip">10. Fun Park</span><img className={"thumb"} style={{width: '150px'}} src={funpark}/></span></span></span>
                </div>
                <div className="circleBase11 type3" onClick={() => setIsPop11(true)} /*onMouseLeave={() => toggleLeave()}
                     onMouseEnter={() => setIsShown7(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">11</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%'}} className="namedTooltip">11. Cable Park</span><img className={"thumb"} style={{width: '150px'}} src={cableImg}/></span></span></span>
                </div>
                <div className="circleBase12 type3" onClick={() => setIsPop12(true)} /*onMouseLeave={() => toggleLeave()}
                     onMouseEnter={() => setIsShown7(true)}*/>
                    <span className="tooltip tooltip-effect-1"><span className="tooltip-item">12</span><span
                        className="tooltip-content clearfix"><span className="tooltip-text"><span style={{width: '100%', left: '0%'}} className="namedTooltip">12. Vita Park</span><img className={"thumb"} style={{width: '150px'}} src={vitaImg}/></span></span></span>
                </div>
                {/*{isShown10 && (
                    showImg10(funpark)
                )}*/}
            </div>
                </TransformComponent>

            {/*</MapInteractionCSS>*/}
            {isPop && (
                popUp1(hotel)
            )}
            {isPop2 && (
                popUp2(lobby)
            )}
            {isPop3 && (
                popUp3(restaurant)
            )}
            {isPop4 && (
                popUp4(salle1)
            )}
            {isPop5 && (
                popUp5(wellness)
            )}
            {isPop6 && (
                popUp6()
            )}
            {isPop7 && (
                popUp7(aquapark)
            )}
            {isPop8 && (
                popUp8(naturapark)
            )}
            {isPop9 && (
                popUp9(naturapark)
            )}
            {isPop11 && (
                popUp11(cable)
            )}
            {isPop12 && (
                popUp12(vita)
            )}
            {isPop10 && (
                popUp10()
            )}
            {/*<span className={"fa fa-minus"}/>
            <input id="ranger" type="range" min="1" max="3" step="0.001" value={size} onChange={e => {
                const {value} = e.target;
                setSize(value)
            }}/>
            <span className={"fa fa-plus"}/>*/}
            </TransformWrapper>
        </div>
    );
}

export default Plan;
